/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { clone, isEmpty, isNil } from "ramda";

import { ThemeProvider } from "@mui/material/styles";
import {
  Autocomplete,
  Badge,
  Button,
  Checkbox,
  Chip,
  Dialog,
  MenuItem,
  Tab,
  Tabs,
  TextField,
  Tooltip,
} from "@mui/material";

import palette from "../../../config/colorPalette";
import { getAlertThemeData, getMuiTheme, menuAccessVerification, parseCSV } from "../../utils/utils";
import { BOOLEAN_MEASURES } from "../../utils/consts";
import { setSelectedMenuOptionAction } from "../../redux/menuSlice";
import NormalDataVisualization from "./components/NormalDataVisualization";
import AddTraceModal from "./components/AddTraceModal";
import {
  handleModalAccept,
  //loadBooleanData,
  loadData,
  //loadDateOptions,
  initialSpatialSelectHandler,
  loadDateOptionsChannel,
  IconDisplay,
  reportFiling,
  manageAlertsAndReports,
  getPointsMap,
  getCurrentIntensityData,
  setEquipmentAndChannelData,
} from "./utils";
import BooleanDataVisualization from "./components/BooleanDataVisualization";
import { scaleLinear, interpolateRgb } from "d3";
// eslint-disable-next-line no-unused-vars
import { getAlertAdditionalInfo, getAllAlertsData, getChunkInfo, getPointsByAssets } from "../../api";
import { setAssetsPointsData } from "../../redux/assetsPointsSlice";
import { setAssetsData } from "../../redux/assetsValuesSlice";
//import ExportToWord from "./components/ExportToWord";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format, parseISO } from "date-fns";
import MapAlert from "./components/MapAlert";
import Carousel from "react-material-ui-carousel";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import noImage from "../../../../src/images/no-image.png";
import CurrentIntensityVisualization from "./components/CurrentIntensityVisualization";
import { TabContext, TabPanel } from "@mui/lab";
import DownloadIcon from "@mui/icons-material/Download";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import { isNumber } from "@turf/turf";
import WaterfallChart from "./components/WaterfallChart";
import { toast } from "react-toastify";
import ADTSVisualization from "./components/ADTSVisualization";
const Analysis = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  const userData = useSelector((state) => state.userData.data);
  const menuData = useSelector((state) => state.menuData.data);
  const assetsData = useSelector((state) => state.assetsData.data);
  const assetsState = useSelector((state) => state.assetsData);
  const assetsPoints = useSelector((state) => state.assetsPoints);
  const configData = useSelector((state) => state.configData.data);
  const equipmentTypes = useSelector((state) => state.equipmentTypeData.data);
  const {
    assetName,
    equipmentID,
    channelParam,
    dateTime,
    startPointIndex,
    endPointIndex,
    startDate,
    alertMeasure,
    // eslint-disable-next-line no-unused-vars
    alertEvent,
    alertModule,
    alertPackage,
  } = useParams();
  let auxAlertMeasure = alertMeasure;
  const [afterAlert, setAfterAlert] = useState(false);
  const [temporalData, setTemporalData] = useState();
  const [minsW, setMinsW] = useState([]);
  const [maxsW, setMaxsW] = useState([]);
  const [startIndex, setStartIndex] = useState();
  const [endIndex, setEndIndex] = useState();

  const [loading, setLoading] = useState(true);
  const [loadingTemporal, setLoadingTemporal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [asset, setAsset] = useState();
  const [assetInfo, setAssetInfo] = useState();
  const [assetModule, setAssetModule] = useState();
  const [assetEvent, setAssetEvent] = useState();
  const [assetEventList, setAssetEventList] = useState();
  const [alertsList, setAlertsList] = useState();
  const [allAlerts, setAllAlerts] = useState();
  const [filter, setFilter] = useState();
  const [assetAlerts, setAssetAlerts] = useState();
  // eslint-disable-next-line no-unused-vars
  const [eventAlerts, setEventAlerts] = useState();
  const [selectedAlert, setSelectedAlert] = useState();
  const [alertAdditionalInfo, setAlertAdditionalInfo] = useState();
  // eslint-disable-next-line no-unused-vars
  const [selectedAdditionalInfo, setSelectedAdditionalInfo] = useState();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [chunk, setChunk] = useState();
  const [disabled, setDisabled] = useState(false);
  const [report, setReport] = useState();
  const [value, setValue] = useState(1);
  const [loadingReport, setLoadingReport] = useState(false);
  const [reportImages, setReportImages] = useState();
  const [dialogImage, setDialogImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [reportFiles, setReportFiles] = useState();
  const [firstTime, setFirstTime] = useState(true);
  const [assetEquipments, setAssetEquipments] = useState();
  const [selectedEquipment, setSelectedEquipment] = useState();
  const [equipment, setEquipment] = useState(null);
  const [equipmentChannels, setEquipmentChannels] = useState();
  const [asignedChannels, setAsignedChannels] = useState();
  const [channel, setChannel] = useState();
  const [subList, setSubList] = useState();
  const [selectedSub, setSelectedSub] = useState();
  const [dateTimeList, setDateTimeList] = useState([]);
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [alertTimes, setAlertTimes] = useState([]); // Variable auxiliar para manejar todas las horas de las alertas de un activo
  const [dateOptions, setDateOptions] = useState([]);
  const [dateOptionsModal, setDateOptionsModal] = useState([]);
  const [timeOptions, setTimeOptions] = useState([]);
  const [timeOptionsModal, setTimeOptionsModal] = useState([]);
  const [measurandsOptions, setMeasurandsOptions] = useState([]);
  const [measurandsFiltered, setMeasurandsFiltered] = useState([]);
  const [nonMeasurands, setNonMeasurands] = useState([]);
  const [percentiles, setPercentiles] = useState();
  const [differences, setDifferences] = useState();
  const [measurementActive, setMeasurementActive] = useState(true);
  const [measurementAny, setMeasurementAny] = useState(true);
  const [dobDates, setDobDates] = useState([]);

  const [data, setData] = useState();
  const dataReceivedRef = useRef(false);
  const pointsReceivedRef = useRef(false);
  // eslint-disable-next-line no-unused-vars
  const [booleanData, setBooleanData] = useState();
  const [currentAsset, setCurrentAsset] = useState();
  const [mapColors, setMapColors] = useState();
  // CURRENT INTENSITY CHARTS
  const [assetSensors, setAssetSensors] = useState();
  const [intensityData, setIntesityData] = useState();
  const [loadingIntensity, setLoadingIntensity] = useState(false);

  const refs = useRef([]);
  const params = useParams();

  // Copia los parámetros a un estado local editable
  const [localParams, setLocalParams] = useState({});

  useEffect(() => {
    setLocalParams(params);
  }, [params]);
  useEffect(() => {
    if (isEmpty(assetsData) && !isNil(assetsState) && !assetsState.loading) {
      setLoading(false);
    }
  }, [assetsData, assetsState]);
  const modulesEvents = {
    thermic: ["measurements", "sDoB", "RTTR", "free_spans"],
    dam: ["measurements", "inclinometers", "leaks"],
    railway: [],
    marine: [],
    road: [],
    intrusion: ["manhole", "perimeter"],
  };

  const chartChunk = useMemo(() => {
    if (!isNil(chunk) && !isEmpty(chunk)) {
      const newDatetimes = chunk.datetime_list.slice(
        chunk.datetime_list.indexOf(chunk.start_date),
        chunk.datetime_list.indexOf(chunk.end_date),
      );
      const newPk = chunk.pk_list.slice(chunk.pk_list.indexOf(chunk.pk_ini), chunk.pk_list.indexOf(chunk.pk_end));
      // TRANSPOSE del heatmap
      const transpose = (matrix) => matrix[0]?.map((_, colIndex) => matrix.map((row) => row[colIndex])) ?? [];

      const transposedData = transpose(chunk.data);

      return {
        yAxis: {
          type: "value",
          text: "PK (m)",
          data: newPk?.map((d) => d.toFixed(2)),
        },
        xAxis: {
          type: "date",
          text: intl.formatMessage({ id: "date" }),
          data: newDatetimes,
        },
        graphic: "Seismic",
        series: [
          {
            data: transposedData,
          },
        ],
        limits: chunk.limit,
        title: "",
      };
    } else {
      return null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chunk]);
  const BadgeReturn = ({ alert }) => {
    const alertData = getAlertThemeData(alert.severity, "small", intl);

    return (
      <Tooltip title={alertData.title} arrow>
        <Badge
          sx={{
            backgroundColor: alertData.backgroundColor,
            justifyContent: "center",
            borderRadius: "16px",
            padding: "5px",
          }}
        >
          {alertData.icon}
        </Badge>
      </Tooltip>
    );
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    //dataReceivedRef.current = false;
    setLoadingReport(true);
    //setAssetModule(event.target.value);
    const reportId = selectedAlert.reports[newValue - 1].id;
    reportFiling({
      id: reportId,
      setReport,
      setReportImages,
      setReportFiles,
      setLoading: setLoadingReport,
    });
  };
  const theme = useMemo(() => getMuiTheme(), []);

  const enabledDates = useMemo(() => {
    if (!isNil(dateOptions) && !isEmpty(dateOptions)) {
      return dateOptions;
    }
  }, [dateOptions]);

  const shouldDisableDate = (date) => {
    // Convertir la fecha a una cadena de fecha sin hora para compararla con las fechas habilitadas
    const dateString = format(date, "yyyy-MM-dd");
    return !enabledDates.some((enabledDate) => enabledDate === dateString);
  };

  useEffect(() => {
    if (menuAccessVerification("/analysis", menuData, navigate)) {
      const i = menuData.find((m) => m.page === "/analysis").value;
      dispatch(setSelectedMenuOptionAction(i));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuData]);

  useEffect(() => {
    if (!isNil(configData)) {
      setMapColors(configData.colorMaps);
    }
  }, [configData]);

  const scales = useMemo(() => {
    if (!isNil(mapColors) && !isEmpty(mapColors)) {
      const jetDomain = [];
      const jetRange = [];
      const seismicDomain = [];
      const seismicRange = [];
      for (let index = 0; index < mapColors["jet"]["blue"].length; index++) {
        jetDomain.push(mapColors["jet"]["value"][index]);
        const redJET = Math.round(mapColors["jet"]["red"][index] * 255);
        const greenJET = Math.round(mapColors["jet"]["green"][index] * 255);
        const blueJET = Math.round(mapColors["jet"]["blue"][index] * 255);
        const hexJET = rgbToHex(redJET, greenJET, blueJET);
        jetRange.push(interpolateRgb(hexJET)(mapColors["jet"]["value"][index]));
        seismicDomain.push(mapColors["seismic"]["value"][index]);
        const redSEISMIC = Math.round(mapColors["seismic"]["red"][index] * 255);
        const greenSEISMIC = Math.round(mapColors["seismic"]["green"][index] * 255);
        const blueSEISMIC = Math.round(mapColors["seismic"]["blue"][index] * 255);
        const hexSeismic = rgbToHex(redSEISMIC, greenSEISMIC, blueSEISMIC);
        seismicRange.push(interpolateRgb(hexSeismic)(mapColors["seismic"]["value"][index]));
      }
      let result = {
        status: scaleLinear()
          .domain([0, 0.55])
          .range([interpolateRgb("green")(0), interpolateRgb("red")(0.55)]),
        "status.secondary": scaleLinear()
          .domain([0, 0.55])
          .range([interpolateRgb("green")(0), interpolateRgb("red")(0.55)]),
        leaks: scaleLinear()
          .domain([0, 0.55])
          .range([interpolateRgb("green")(0), interpolateRgb("red")(0.55)]),
        temperature: scaleLinear().domain(jetDomain).range(jetRange),
        temperature_matrix: scaleLinear().domain(jetDomain).range(jetRange),
        conductivity: scaleLinear().domain(jetDomain).range(jetRange),
        voltages: scaleLinear().domain(jetDomain).range(jetRange),
        currents: scaleLinear().domain(jetDomain).range(jetRange),
        landslide: scaleLinear()
          .domain([0, 0.55])
          .range([interpolateRgb("green")(0), interpolateRgb("red")(0.55)]),
        strain: scaleLinear().domain(seismicDomain).range(seismicRange),
      };
      return result;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapColors]);

  function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  }

  function rgbToHex(r, g, b) {
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
  }

  function obtainExtension(file) {
    const parts = file.split(".");
    return parts.length > 1 ? parts.pop().toLowerCase() : "";
  }

  function fileType(extension, fileTypes) {
    if (fileTypes.includes(extension)) {
      return true;
    }
    return null;
  }

  const goToPrevious = async () => {
    setDisabled(true);
    const newIndex = currentIndex === 0 ? alertAdditionalInfo.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
    const newChunk = await getChunkInfo(alertAdditionalInfo[newIndex].id);
    setChunk(newChunk.data.data);
    setDisabled(false);
  };

  const goToNext = async () => {
    setDisabled(true);
    const newIndex = currentIndex === alertAdditionalInfo.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
    const newChunk = await getChunkInfo(alertAdditionalInfo[newIndex].id);
    setChunk(newChunk.data.data);
    setDisabled(false);
  };
  useEffect(() => {
    async function initialInfo() {
      if (
        !isNil(assetsData) &&
        !isEmpty(assetsData) &&
        !isNil(userData) &&
        !isNil(configData) &&
        isNil(asset) &&
        isNil(currentAsset)
      ) {
        const assetInit = !isNil(assetName)
          ? assetName
          : (() => {
              const assetWithConfig = assetsData.find(
                (a) => (a.config?.measurands?.length ?? 0) > 0 || (a.config?.modules?.length ?? 0) > 0,
              );
              return assetWithConfig ? assetWithConfig.name : assetsData[0].name;
            })();
        setAsset(assetInit);
        const alertsListResponse = await getAllAlertsData();
        let newAlerts = clone(alertsListResponse.data.data);
        newAlerts.equipments = alertsListResponse.data.data.equipments.filter((alert) => !alert.isArchived);
        newAlerts.measurements = alertsListResponse.data.data.measurements.filter((alert) => !alert.isArchived);
        setAlertsList(newAlerts);
        setAllAlerts(alertsListResponse.data.data);
        const newAssetInfo = assetsData?.find((a) => a.name === assetInit);
        setAssetInfo(newAssetInfo);
        const moduleInit = !isNil(alertModule) ? alertModule : newAssetInfo.config?.modules?.[0].name;
        const anyTrue = newAssetInfo.config?.modules?.[0].packages.some((pack) => pack.measurand);
        setMeasurementAny(anyTrue);
        let filterInit = null;
        if (!isNil(alertModule) || !anyTrue) {
          filterInit = "alerts";
          setFilter("alerts");
        } else {
          filterInit = "measurands";
          setFilter("measurands");
        }
        if (filterInit === "measurands") {
          setAssetAlerts();
        } else {
          setAssetAlerts(alertsListResponse.data.data.measurements.filter((alert) => alert.asset === assetInit));
        }
        const newSubstructures = [];
        for (let indexSub = 0; indexSub < newAssetInfo.substructures.length; indexSub++) {
          for (let indexEquipment = 0; indexEquipment < newAssetInfo.equipments.length; indexEquipment++) {
            if (filterInit === "measurands" && newAssetInfo.equipments[indexEquipment].equipmentType !== "DAS") {
              for (
                let indexChannel = 0;
                indexChannel < newAssetInfo.equipments[indexEquipment].channels.length;
                indexChannel++
              ) {
                const channelSubs = newAssetInfo.equipments[indexEquipment].channels[indexChannel].substructures;

                const subFound = channelSubs.includes(newAssetInfo.substructures[indexSub].ref);
                if (subFound) newSubstructures.push(newAssetInfo.substructures[indexSub]);
              }
            } else if (filterInit === "alerts" && newAssetInfo.equipments[indexEquipment].equipmentType === "DAS") {
              for (
                let indexChannel = 0;
                indexChannel < newAssetInfo.equipments[indexEquipment].channels.length;
                indexChannel++
              ) {
                const channelSubs = newAssetInfo.equipments[indexEquipment].channels[indexChannel].substructures;

                const subFound = channelSubs.includes(newAssetInfo.substructures[indexSub].ref);
                if (subFound) newSubstructures.push(newAssetInfo.substructures[indexSub]);
              }
            }
          }
        }
        setSubList(newSubstructures);
        setSelectedSub(newSubstructures[0]);
        setEquipmentAndChannelData({
          assetInfo: newAssetInfo,
          subList: newSubstructures,
          selectedSub: newSubstructures[0],
          configData,
          channelParam,
          equipmentID,
          equipmentTypes,
          moduleName: moduleInit,
          newPackage: alertPackage,
          param: !isNil(alertModule),
          anyTrue,
          localParams: params,
          setAsignedChannels,
          setAssetEquipments,
          setChannel,
          setEquipment,
          setEquipmentChannels,
          setMeasurandsFiltered,
          setMeasurandsOptions,
          setSelectedEquipment,
          setSelectedSub,
          setSubList,
          setFilter,
          alertsList: alertsListResponse.data.data,
          setAssetAlerts,
          setAssetEvent,
          setAssetEventList,
          setDateTimeList,
          setAssetSensors,
          setSelectedAlert,
          setMeasurementActive,
          setNonMeasurands,
        });
        setAssetModule(moduleInit);
      }
    }
    initialInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetsData, userData, configData]);
  useEffect(() => {
    async function setInfo() {
      if (!isNil(asset) && !isNil(assetsData)) {
        const newAssetInfo = assetsData?.find((a) => a.name === asset);
        setAssetInfo(newAssetInfo);

        const moduleInit = newAssetInfo.config?.modules?.[0]?.name;
        const anyTrue = newAssetInfo.config?.modules?.[0].packages.some((pack) => pack.measurand);
        setMeasurementAny(anyTrue);
        let filterInit = null;
        if (!anyTrue) {
          filterInit = "alerts";
          setFilter("alerts");
        } else {
          filterInit = "measurands";
          setFilter("measurands");
        }
        const newSubstructures = [];
        for (let indexSub = 0; indexSub < newAssetInfo.substructures.length; indexSub++) {
          for (let indexEquipment = 0; indexEquipment < newAssetInfo.equipments.length; indexEquipment++) {
            if (filterInit === "measurands" && newAssetInfo.equipments[indexEquipment].equipmentType !== "DAS") {
              for (
                let indexChannel = 0;
                indexChannel < newAssetInfo.equipments[indexEquipment].channels.length;
                indexChannel++
              ) {
                const channelSubs = newAssetInfo.equipments[indexEquipment].channels[indexChannel].substructures;

                const subFound = channelSubs.includes(newAssetInfo.substructures[indexSub].ref);
                if (subFound) newSubstructures.push(newAssetInfo.substructures[indexSub]);
              }
            } else if (filterInit === "alerts" && newAssetInfo.equipments[indexEquipment].equipmentType === "DAS") {
              for (
                let indexChannel = 0;
                indexChannel < newAssetInfo.equipments[indexEquipment].channels.length;
                indexChannel++
              ) {
                const channelSubs = newAssetInfo.equipments[indexEquipment].channels[indexChannel].substructures;

                const subFound = channelSubs.includes(newAssetInfo.substructures[indexSub].ref);
                if (subFound) newSubstructures.push(newAssetInfo.substructures[indexSub]);
              }
            }
          }
        }
        setSubList(newSubstructures);
        setSelectedSub(newSubstructures[0]);
        if (!isNil(assetEquipments) && asset !== assetEquipments[0].asset) {
          setEquipmentAndChannelData({
            setAssetSensors,
            assetInfo: newAssetInfo,
            selectedSub: newSubstructures[0],
            subList: newSubstructures,
            configData,
            channelParam: null,
            equipmentID: null,
            equipmentTypes,
            moduleName: moduleInit,
            newPackage: null,
            anyTrue,
            param: false,
            setAssetEquipments,
            setAsignedChannels,
            setChannel,
            setEquipment,
            setEquipmentChannels,
            setMeasurandsFiltered,
            setMeasurandsOptions,
            setSelectedEquipment,
            setSelectedSub,
            setSubList,
            setFilter,
            alertsList,
            setAssetAlerts,
            setAssetEvent,
            setAssetEventList,
            setDateTimeList,
            setSelectedAlert,
            setMeasurementActive,
            setNonMeasurands,
          });
          setAssetModule(moduleInit);
          setDateTimeList([]);
          setIntesityData();
        }
      }
    }
    setInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asset, assetsData]);

  useEffect(() => {
    async function getTimes() {
      if (!isNil(asset)) {
        if (!isNil(filter) && filter === "measurands") {
          setIntesityData();
          if (isNil(channel)) {
            const print = selectedEquipment?.channels.findIndex((channel) => channel.state);
            if (print >= 0) {
              setChannel(print + 1);
              const newSubList = [];
              for (let indexChannel = 0; indexChannel < selectedEquipment.channels.length; indexChannel++) {
                if (selectedEquipment.channels[indexChannel].state) {
                  const channelSubs = selectedEquipment.channels[indexChannel].substructures;
                  const subsFound = assetInfo.substructures.filter((sub) => channelSubs.includes(sub.ref));

                  newSubList.push(...subsFound);
                }
              }
              setSubList(newSubList);
              setSelectedSub(newSubList[0]);
            }
          }
          loadDateOptionsChannel({
            setDateOptions,
            setDateOptionsModal,
            setTimeOptions,
            setTimeOptionsModal,
            assetEquipments,
            equipmentChannels,
            asset,
            assetInfo,
            equipment,
            channel,
            selectedSub,
            setSelectedSub,
            dateTime,
            setDate,
            setTime,
            setChannel,
            firstTime,
            setFirstTime,
            selectedEquipment,
            setSelectedEquipment,
          });
        }
      }
    }
    getTimes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetModule, selectedSub, filter]);

  useEffect(() => {
    if (!isNil(assetAlerts) && !isEmpty(assetAlerts) && !isNil(assetModule) && filter === "alerts") {
      manageAlertsAndReports({
        assetAlerts,
        modulesEvents,
        setSelectedAlert,
        assetModule,
        actualEvent: !isNil(localParams) && !isNil(localParams.alertPackage) ? localParams.alertPackage : assetEvent,
        dateTime: !isNil(localParams) && !isNil(localParams.dateTime) ? localParams.dateTime : dateTime,
        localParams,
        setAlertTimes,
        setAssetEvent,
        setEventAlerts,
        setReport,
        setReportImages,
        setReportFiles,
        setDate,
        setTime,
        setDateOptions,
        setTimeOptions,
        setDateOptionsModal,
        setTimeOptionsModal,
        setAlertAdditionalInfo,
        setSelectedAdditionalInfo,
        setChunk,
        setLoading,
      });
      getPointsMap({ asset, assetsPoints, dispatch, setAssetsPointsData });
      setLocalParams(null);
    } else if (filter === "alerts") {
      setDateOptions(null);
      setTimeOptions(null);
      setDateOptionsModal(null);
      setTimeOptionsModal(null);
      setDate(null);
      setTime(null);
      setDateTimeList([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetAlerts]);

  useEffect(() => {
    if (!isNil(date) && !isNil(time) && !isNil(dateOptions) && !isNil(timeOptions)) {
      const newDateTime = `${dateOptions[date]}T${timeOptions[time]}`;
      if (!isNil(dateTimeList) && !isNil(dateOptions[date]) && !isNil(timeOptions[time])) {
        if (!isNil(selectedSub) && typeof selectedSub.polyline === "string" && filter === "measurands") {
          setDateTimeList([[newDateTime, channel, selectedSub.polyline, selectedSub]]);
        }
        if (filter === "alerts") {
          setDateTimeList([[newDateTime, channel]]);
        }
      }
    } else {
      setData({});
      dispatch(setAssetsPointsData({}));
      dispatch(setAssetsData({}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, time, dateOptions, timeOptions]);
  useEffect(() => {
    async function getDataAndPoints() {
      const alreadyPoints = assetsPoints.data;
      if (!isNil(alreadyPoints)) {
        const puntosExistentes = (alreadyPoints, asset) => {
          return Object.keys(alreadyPoints).some((key) => key.startsWith(asset));
        };
        if (!puntosExistentes(alreadyPoints, asset) && !isNil(asset)) {
          const response = await getPointsByAssets(asset);
          const pointsMap = {};
          for (let index = 0; index < response.data.data.length; index++) {
            pointsMap[`${asset}_${response.data.data[index].id}_${response.data.data[index].equipment_type}`] =
              response.data.data[index];
          }
          dispatch(setAssetsPointsData(pointsMap));
        }
      }
      if (
        !isNil(asset) &&
        !isNil(dateTimeList) &&
        !isEmpty(dateTimeList) &&
        !isNil(assetsData) &&
        !isNil(selectedEquipment) &&
        !isNil(assetsPoints.data) &&
        !isEmpty(assetsPoints.data) &&
        !dataReceivedRef.current &&
        !isNil(assetsPoints.data[`${asset}_${selectedSub.polyline}_${selectedEquipment.equipmentType}`])
      ) {
        dataReceivedRef.current = true;
        loadData({
          asset: assetInfo,
          assetModule,
          selectedEquipment,
          points: assetsPoints.data,
          dateTimeList,
          data,
          equipment_ID: equipment,
          channel: channel,
          asignedChannels,
          selectedSub,
          subList,
          measurandsFiltered,
          setData,
          setBooleanData,
          setLoading,
          setPercentiles,
          setDifferences,
          dobDates,
          setDobDates,
        });
        if (isNil(currentAsset) || currentAsset.name !== asset) {
          const thisAsset = assetsData.find((a) => a.name === asset);
          if (!isNil(thisAsset)) {
            setCurrentAsset(thisAsset);
            if (thisAsset.config?.additionalSensors?.active) {
              setAssetSensors(thisAsset.config?.additionalSensors?.sensors);
            }
          }
        }
      }
    }
    if (!isNil(assetModule) && filter === "measurands") {
      getDataAndPoints();
    } else {
      if (!isNil(assetsData) && !isEmpty(assetsData) && (isNil(currentAsset) || currentAsset.name !== asset)) {
        const thisAsset = assetsData.find((a) => a.name === asset);
        if (!isNil(thisAsset)) {
          setCurrentAsset(thisAsset);
          if (thisAsset.config?.additionalSensors?.active) {
            setAssetSensors(thisAsset.config?.additionalSensors?.sensors);
          }
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateTimeList, assetsPoints]);

  if (isEmpty(assetsData)) {
    return (
      <div style={{ height: "92vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        {`${intl.formatMessage({ id: "no.data" })}.`}
      </div>
    );
  }
  if (isNil(assetsData) || isNil(data) || loading) {
    const message =
      !loading &&
      ((isNil(dateOptions) &&
        isNil(timeOptions) &&
        isNil(dateOptionsModal) &&
        isNil(timeOptionsModal) &&
        isNil(date) &&
        isNil(time)) ||
        isNil(assetsData))
        ? "data.didnt.came"
        : "loading";

    return (
      <div style={{ height: "92vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        {`${intl.formatMessage({ id: message })}`}
        {message === "data.didnt.came" && !isNil(assetsData) && isNil(data.length) ? (
          <>
            {` ${intl.formatMessage({ id: "select.another.asset" })}`}
            <TextField
              variant="outlined"
              margin="dense"
              id="asset"
              label={intl.formatMessage({ id: "Asset" })}
              select
              style={{ width: 150, margin: "1%" }}
              value={asset}
              onChange={(event) => {
                navigate("/analysis", { replace: true });
                const assetWithConfig = assetsData.find((a) => a.name === event.target.value);
                if (!isNil(assetWithConfig.config.modules)) {
                  setLoading(true);
                  pointsReceivedRef.current = false;
                  dataReceivedRef.current = false;
                  setFirstTime(true);
                  setAsset(event.target.value);
                }
              }}
            >
              {assetsData.map((opt) => (
                <MenuItem key={opt.name} value={opt.name}>
                  {opt.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              variant="outlined"
              margin="dense"
              id="module"
              label={intl.formatMessage({ id: "module" })}
              disabled={
                !isNil(assetInfo) ||
                !isNil(assetInfo?.config) ||
                !isNil(assetInfo?.config.modules) ||
                !isEmpty(assetInfo?.config.modules) ||
                assetInfo?.config?.modules?.length === 1
              }
              select
              style={{ width: 150 }}
              value={assetModule}
              onChange={(event) => {
                navigate("/analysis", { replace: true });
                dataReceivedRef.current = false;
                setLoading(true);
                const moduleInit = assetInfo.config?.modules?.find((module) => module.name === event.target.value);
                const anyTrue = moduleInit.packages.some((pack) => pack.measurand);
                setMeasurementAny(anyTrue);
                let filterInit = null;
                if (!anyTrue) {
                  filterInit = "alerts";
                  setFilter("alerts");
                } else {
                  filterInit = "measurands";
                  setFilter("measurands");
                }
                const newSubstructures = [];
                for (let indexSub = 0; indexSub < assetInfo.substructures.length; indexSub++) {
                  for (let indexEquipment = 0; indexEquipment < assetInfo.equipments.length; indexEquipment++) {
                    if (filterInit === "measurands" && assetInfo.equipments[indexEquipment].equipmentType !== "DAS") {
                      for (
                        let indexChannel = 0;
                        indexChannel < assetInfo.equipments[indexEquipment].channels.length;
                        indexChannel++
                      ) {
                        const channelSubs = assetInfo.equipments[indexEquipment].channels[indexChannel].substructures;

                        const subFound = channelSubs.includes(assetInfo.substructures[indexSub].ref);
                        if (subFound) newSubstructures.push(assetInfo.substructures[indexSub]);
                      }
                    } else if (
                      filterInit === "alerts" &&
                      assetInfo.equipments[indexEquipment].equipmentType === "DAS"
                    ) {
                      for (
                        let indexChannel = 0;
                        indexChannel < assetInfo.equipments[indexEquipment].channels.length;
                        indexChannel++
                      ) {
                        const channelSubs = assetInfo.equipments[indexEquipment].channels[indexChannel].substructures;

                        const subFound = channelSubs.includes(assetInfo.substructures[indexSub].ref);
                        if (subFound) newSubstructures.push(assetInfo.substructures[indexSub]);
                      }
                    }
                  }
                }
                setSubList(newSubstructures);
                setSelectedSub(newSubstructures[0]);
                setEquipmentAndChannelData({
                  setAssetSensors,
                  assetInfo,
                  selectedSub: newSubstructures[0],
                  subList: newSubstructures,
                  configData,
                  channelParam: null,
                  equipmentID: null,
                  equipmentTypes,
                  moduleName: event.target.value,
                  anyTrue,
                  newPackage: null,
                  param: false,
                  setAssetEquipments,
                  setAsignedChannels,
                  setChannel,
                  setEquipment,
                  setEquipmentChannels,
                  setMeasurandsFiltered,
                  setMeasurandsOptions,
                  setSelectedEquipment,
                  setSelectedSub,
                  setSubList,
                  setFilter,
                  alertsList,
                  setAssetAlerts,
                  setAssetEvent,
                  setAssetEventList,
                  setDateTimeList,
                  setSelectedAlert,
                  setMeasurementActive,
                  setNonMeasurands,
                });
                setAssetModule(event.target.value);
              }}
            >
              {assetInfo?.config?.modules?.map((cModule, moduleIndex) => (
                <MenuItem key={`${cModule}_${moduleIndex}`} value={cModule.name}>
                  {intl.formatMessage({ id: cModule.name })}
                </MenuItem>
              ))}
            </TextField>
          </>
        ) : null}
        {message === "loading" && "..."}
      </div>
    );
  }

  if (!isNil(assetsData) && !loading) {
    return (
      <>
        <ThemeProvider theme={theme}>
          <div style={{ width: "100%", height: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "0.5rem",
                padding: "1rem",
                width: "99%",
              }}
            >
              <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
                <TextField
                  variant="outlined"
                  margin="dense"
                  id="asset"
                  label={intl.formatMessage({ id: "Asset" })}
                  select
                  style={{ width: 150 }}
                  value={asset}
                  onChange={(event) => {
                    navigate("/analysis", { replace: true });
                    const assetWithConfig = assetsData.find((a) => a.name === event.target.value);
                    if (!isNil(assetWithConfig.config?.modules)) {
                      pointsReceivedRef.current = false;
                      dataReceivedRef.current = false;
                      setLoading(true);
                      setFirstTime(true);
                      setAsset(event.target.value);
                      setChannel(null);
                    }
                  }}
                >
                  {assetsData.map((opt) => (
                    <MenuItem key={opt.name} value={opt.name}>
                      {opt.name}
                    </MenuItem>
                  ))}
                </TextField>
                {!isNil(assetInfo) && !isNil(assetInfo?.config.modules) && (
                  <TextField
                    variant="outlined"
                    margin="dense"
                    id="module"
                    label={intl.formatMessage({ id: "module" })}
                    select
                    disabled={assetInfo?.config?.modules?.length <= 1}
                    style={{ width: 150 }}
                    value={assetModule}
                    onChange={(event) => {
                      navigate("/analysis", { replace: true });
                      dataReceivedRef.current = false;
                      setLoading(true);
                      navigate("/analysis", { replace: true });
                      const moduleInit = assetInfo.config?.modules?.find(
                        (module) => module.name === event.target.value,
                      );
                      const anyTrue = moduleInit.packages.some((pack) => pack.measurand);
                      setMeasurementAny(anyTrue);
                      let filterInit = null;
                      if (!anyTrue) {
                        filterInit = "alerts";
                        setFilter("alerts");
                      } else {
                        filterInit = "measurands";
                        setFilter("measurands");
                      }
                      const newSubstructures = [];
                      for (let indexSub = 0; indexSub < assetInfo.substructures.length; indexSub++) {
                        for (let indexEquipment = 0; indexEquipment < assetInfo.equipments.length; indexEquipment++) {
                          if (
                            filterInit === "measurands" &&
                            assetInfo.equipments[indexEquipment].equipmentType !== "DAS"
                          ) {
                            for (
                              let indexChannel = 0;
                              indexChannel < assetInfo.equipments[indexEquipment].channels.length;
                              indexChannel++
                            ) {
                              const channelSubs =
                                assetInfo.equipments[indexEquipment].channels[indexChannel].substructures;

                              const subFound = channelSubs.includes(assetInfo.substructures[indexSub].ref);
                              if (subFound) newSubstructures.push(assetInfo.substructures[indexSub]);
                            }
                          } else if (
                            filterInit === "alerts" &&
                            assetInfo.equipments[indexEquipment].equipmentType === "DAS"
                          ) {
                            for (
                              let indexChannel = 0;
                              indexChannel < assetInfo.equipments[indexEquipment].channels.length;
                              indexChannel++
                            ) {
                              const channelSubs =
                                assetInfo.equipments[indexEquipment].channels[indexChannel].substructures;

                              const subFound = channelSubs.includes(assetInfo.substructures[indexSub].ref);
                              if (subFound) newSubstructures.push(assetInfo.substructures[indexSub]);
                            }
                          }
                        }
                      }
                      setSubList(newSubstructures);
                      setSelectedSub(newSubstructures[0]);
                      setEquipmentAndChannelData({
                        setAssetSensors,
                        selectedSub: newSubstructures[0],
                        subList: newSubstructures,
                        assetInfo,
                        configData,
                        channelParam: null,
                        equipmentID: null,
                        equipmentTypes,
                        moduleName: event.target.value,
                        anyTrue,
                        newPackage: null,
                        param: false,
                        setAsignedChannels,
                        setChannel,
                        setAssetEquipments,
                        setEquipment,
                        setEquipmentChannels,
                        setMeasurandsFiltered,
                        setMeasurandsOptions,
                        setSelectedEquipment,
                        setSelectedSub,
                        setSubList,
                        setFilter,
                        alertsList,
                        setAssetAlerts,
                        setAssetEvent,
                        setAssetEventList,
                        setDateTimeList,
                        setSelectedAlert,
                        setMeasurementActive,
                        setNonMeasurands,
                      });
                      setAssetModule(event.target.value);
                    }}
                  >
                    {assetInfo?.config.modules.map((cModule, moduleIndex) => (
                      <MenuItem key={`${cModule}_${moduleIndex}`} value={cModule.name}>
                        {intl.formatMessage({ id: cModule.name })}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
                <TextField
                  variant="outlined"
                  margin="dense"
                  id="filter_type"
                  label={intl.formatMessage({ id: "type" })}
                  select
                  style={{ width: 150 }}
                  value={filter}
                  onChange={(event) => {
                    navigate("/analysis", { replace: true });
                    dataReceivedRef.current = false;
                    if (event.target.value === "alerts") {
                      const newSubstructures = [];
                      for (let indexSub = 0; indexSub < assetInfo.substructures.length; indexSub++) {
                        for (let indexEquipment = 0; indexEquipment < assetInfo.equipments.length; indexEquipment++) {
                          const currentEquipmentType = equipmentTypes.find(
                            (et) => et.name === assetInfo.equipments[indexEquipment].equipmentType,
                          );
                          const moduleFound = currentEquipmentType.modules.find(
                            (module) => module.module === assetModule,
                          );
                          if (!isNil(moduleFound) && !isEmpty(moduleFound)) {
                            for (
                              let indexChannel = 0;
                              indexChannel < assetInfo.equipments[indexEquipment].channels.length;
                              indexChannel++
                            ) {
                              const channelSubs =
                                assetInfo.equipments[indexEquipment].channels[indexChannel].substructures;

                              const subFound = channelSubs.includes(assetInfo.substructures[indexSub].ref);
                              if (subFound) newSubstructures.push(assetInfo.substructures[indexSub]);
                            }
                          }
                        }
                      }
                      setSubList(newSubstructures);
                      setSelectedSub(newSubstructures[0]);
                      const newEquipment = assetInfo.equipments.find((item) => item.equipmentID === equipment);
                      setSelectedEquipment(newEquipment);
                      const printChannel = newEquipment.channels.findIndex(
                        (channel) =>
                          channel.state && channel.substructures.find((sub) => sub === newSubstructures[0].ref),
                      );

                      if (printChannel >= 0) {
                        setAsignedChannels(newEquipment.channels);
                        const print = !isNil(channelParam) ? parseInt(channelParam) : printChannel + 1;
                        setChannel(print);
                      }

                      const newAlertList = alertsList.measurements.filter(
                        (alert) =>
                          alert.asset === asset &&
                          alert.module === assetModule &&
                          alert.substructure === newSubstructures[0].ref,
                      );
                      const auxEvents = newAlertList.map((alert) => alert.package);
                      const newEvents = auxEvents.filter((item, index) => auxEvents.indexOf(item) === index);
                      setAssetEventList(newEvents);
                      setAssetEvent(newEvents[0]);
                      setAssetAlerts(newAlertList);
                      //setAsignedChannels(null);
                      //setChannel(null);
                      //setSubList(null);
                      //setSelectedSub(null);
                      setDateTimeList([]);
                      //setEquipmentChannels(null);
                    } else {
                      setAssetAlerts();
                      setDateTimeList([]);
                      setDateOptions(null);
                      setTimeOptions(null);
                      setDateOptionsModal(null);
                      setTimeOptionsModal(null);
                      const newSubstructures = [];
                      for (let indexSub = 0; indexSub < assetInfo.substructures.length; indexSub++) {
                        for (let indexEquipment = 0; indexEquipment < assetInfo.equipments.length; indexEquipment++) {
                          if (assetInfo.equipments[indexEquipment].equipmentType !== "DAS") {
                            for (
                              let indexChannel = 0;
                              indexChannel < assetInfo.equipments[indexEquipment].channels.length;
                              indexChannel++
                            ) {
                              const channelSubs =
                                assetInfo.equipments[indexEquipment].channels[indexChannel].substructures;

                              const subFound = channelSubs.includes(assetInfo.substructures[indexSub].ref);
                              if (subFound) newSubstructures.push(assetInfo.substructures[indexSub]);
                            }
                          }
                        }
                      }
                      setSubList(newSubstructures);
                      setSelectedSub(newSubstructures[0]);
                      setEquipmentAndChannelData({
                        setAssetSensors,
                        selectedSub: newSubstructures[0],
                        subList: newSubstructures,
                        assetInfo,
                        configData,
                        channelParam,
                        equipmentID,
                        equipmentTypes,
                        moduleName: assetModule,
                        anyTrue: measurementAny,
                        newPackage: null,
                        param: false,
                        setAsignedChannels,
                        setAssetEquipments,
                        setChannel,
                        setEquipment,
                        setEquipmentChannels,
                        setMeasurandsFiltered,
                        setMeasurandsOptions,
                        setSelectedEquipment,
                        setSelectedSub,
                        setSubList,
                        setFilter,
                        alertsList,
                        setAssetAlerts,
                        setAssetEvent,
                        setAssetEventList,
                        setDateTimeList,
                        setSelectedAlert,
                        setMeasurementActive,
                        setNonMeasurands,
                      });
                    }

                    setFilter(event.target.value);
                  }}
                >
                  {measurementActive && measurementAny && (
                    <MenuItem key={`measurands_filter`} value={"measurands"}>
                      {intl.formatMessage({ id: "measurands" })}
                    </MenuItem>
                  )}
                  <MenuItem key={`alerts_filter`} value={"alerts"}>
                    {intl.formatMessage({ id: "alerts" })}
                  </MenuItem>
                </TextField>
                {filter === "measurands" && (
                  <>
                    {!isNil(subList) && (
                      <TextField
                        select
                        style={{ width: 150 }}
                        id="sub_list"
                        variant="outlined"
                        label={intl.formatMessage({ id: "sub" })}
                        margin="dense"
                        value={selectedSub}
                        onChange={(event) => {
                          navigate("/analysis", { replace: true });
                          dataReceivedRef.current = false;
                          setSelectedSub(event.target.value);
                          setEquipmentAndChannelData({
                            setAssetSensors,
                            assetInfo,
                            configData,
                            channelParam: null,
                            equipmentID: null,
                            equipmentTypes,
                            moduleName: assetModule,
                            newPackage: null,
                            anyTrue: measurementAny,
                            selectedSub: event.target.value,
                            subList: subList,
                            param: false,
                            setAssetEquipments,
                            setAsignedChannels,
                            setChannel,
                            setEquipment,
                            setEquipmentChannels,
                            setMeasurandsFiltered,
                            setMeasurandsOptions,
                            setSelectedEquipment,
                            setSelectedSub,
                            setSubList,
                            setFilter,
                            alertsList,
                            setAssetAlerts,
                            setAssetEvent,
                            setAssetEventList,
                            setDateTimeList,
                            setSelectedAlert,
                            setMeasurementActive,
                            setNonMeasurands,
                          });
                        }}
                      >
                        {subList.map((sub, i) => {
                          return (
                            <MenuItem key={`${sub.name}_current_select_${i}`} value={sub}>
                              {sub.name}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    )}
                    {!isNil(assetEquipments) &&
                      (() => {
                        const actualChannel = selectedEquipment.channels[channel - 1];
                        return (
                          <TextField
                            select
                            style={{ width: 150 }}
                            id="asset_equipments"
                            variant="outlined"
                            label={intl.formatMessage({ id: "equipments" })}
                            margin="dense"
                            value={`${equipment}|${actualChannel.name}`}
                            onChange={(event) => {
                              navigate("/analysis", { replace: true });
                              dataReceivedRef.current = false;
                              setLoading(true);
                              const [selectedEquipmentID, selectedChannelName] = event.target.value.split("|");
                              const newEquipment = assetInfo.equipments.find(
                                (item) => item.equipmentID === selectedEquipmentID,
                              );
                              setSelectedEquipment(newEquipment);
                              const newMeasurands = [];
                              for (
                                let indexMeasurand = 0;
                                indexMeasurand < assetInfo?.config?.modules?.length;
                                indexMeasurand++
                              ) {
                                const actualModule = assetInfo.config.modules[indexMeasurand];
                                if (actualModule.name === assetModule) {
                                  const auxPack = actualModule.packages.filter((pack) => pack.measurand);
                                  const newPackages = auxPack.map((pack) => pack.name);
                                  newMeasurands.push(...newPackages);
                                }
                              }
                              const noRepeating = [...new Set(newMeasurands)];
                              if (!isEmpty(noRepeating)) {
                                setFilter("measurands");
                                setMeasurandsOptions(noRepeating);
                                setMeasurandsFiltered(noRepeating);
                                setSelectedEquipment(newEquipment);
                                const menuItems = [];
                                for (let index = 0; index < newEquipment.channels.length; index++) {
                                  menuItems.push(index + 1);
                                }

                                const printChannel = newEquipment.channels.findIndex(
                                  (channel) => channel.name === selectedChannelName,
                                );
                                if (printChannel >= 0) {
                                  setAsignedChannels(newEquipment.channels);
                                  const print = !isNil(channelParam) ? parseInt(channelParam) : printChannel + 1;
                                  setChannel(print);
                                  setEquipmentChannels(menuItems);
                                } else {
                                  setAsignedChannels(null);
                                  setChannel(null);
                                  setSubList(null);
                                  setSelectedSub(null);
                                  setEquipmentChannels(null);
                                }
                              }
                            }}
                          >
                            {assetEquipments.map((ae, i) =>
                              ae.channels.map((channel) => {
                                const found = channel.substructures.find((sub) => sub === selectedSub.ref);
                                if (isNil(found) || isEmpty(found)) return null;
                                return (
                                  <MenuItem
                                    key={`${ae.equipmentID}_current_select_${i}`}
                                    value={`${ae.equipmentID}|${channel.name}`}
                                  >
                                    {ae.name} - {channel.name}
                                  </MenuItem>
                                );
                              }),
                            )}
                          </TextField>
                        );
                      })()}
                  </>
                )}
                {filter === "alerts" && (
                  <>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      id="events"
                      label={intl.formatMessage({ id: "event" })}
                      select
                      style={{ width: 150 }}
                      value={assetEvent}
                      onChange={(event) => {
                        navigate("/analysis", { replace: true });
                        dataReceivedRef.current = false;
                        setLoading(true);
                        setAssetEvent(event.target.value);
                        manageAlertsAndReports({
                          assetAlerts,
                          modulesEvents,
                          setSelectedAlert,
                          assetModule,
                          actualEvent: event.target.value,
                          setAlertTimes,
                          setEventAlerts,
                          setReport,
                          setReportImages,
                          setReportFiles,
                          setDate,
                          setTime,
                          setDateOptions,
                          setTimeOptions,
                          setDateOptionsModal,
                          setTimeOptionsModal,
                          setAlertAdditionalInfo,
                          setSelectedAdditionalInfo,
                          setChunk,
                          setLoading,
                        });
                        //setAssetModule(event.target.value);
                      }}
                    >
                      {assetEventList.map((event) => (
                        <MenuItem key={`${event}_intrusion`} value={event}>
                          {intl.formatMessage({ id: event })}
                        </MenuItem>
                      ))}
                    </TextField>
                  </>
                )}
                {filter === "measurands" && (
                  <>
                    {!isNil(dateOptions) && !isEmpty(dateOptions) && (
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          id="date_picker"
                          label={intl.formatMessage({ id: "date" })}
                          shouldDisableDate={shouldDisableDate}
                          format="dd-MM-yyyy"
                          value={parseISO(dateOptions[date])}
                          onChange={async (e) => {
                            dataReceivedRef.current = false;
                            navigate("/analysis", { replace: true });
                            setLoading(true);
                            const date = new Date(e);

                            const year = date.getFullYear();
                            const month = ("0" + (date.getMonth() + 1)).slice(-2);
                            const day = ("0" + date.getDate()).slice(-2);

                            const formattedDate = year + "-" + month + "-" + day;
                            if (filter === "measurands") {
                              loadDateOptionsChannel({
                                //setDateOptions,
                                setTimeOptions,
                                date: dateOptions[dateOptions.indexOf(formattedDate)],
                                dateOptions,
                                assetEquipments,
                                asset,
                                assetInfo,
                                equipment,
                                channel,
                                equipmentChannels,
                                setDate,
                                setTime,
                                firstTime,
                                setFirstTime,
                                selectedEquipment,
                                setSelectedEquipment,
                                selectedSub,
                                setSelectedSub,
                              });
                            }
                            if (filter === "alerts") {
                              const indexDate = dateOptions.indexOf(formattedDate);
                              setDate(indexDate);
                              setTimeOptions(alertTimes[indexDate]);
                              setTimeOptionsModal(alertTimes[indexDate]);
                              const newFormattedDate = `${dateOptions[indexDate]}T${alertTimes[indexDate][0]}`;
                              const actualAlert = assetAlerts.find(
                                (alert) =>
                                  alert.dateStart === newFormattedDate ||
                                  alert.dateStart === `${dateOptions[indexDate]} ${alertTimes[indexDate][0]}`,
                              );
                              const newAdditionalInfo = await getAlertAdditionalInfo(actualAlert.id);
                              setAlertAdditionalInfo(newAdditionalInfo.data.data); // esto se setea para conseguir los chunks
                              if (!isEmpty(newAdditionalInfo.data.data)) {
                                setSelectedAdditionalInfo(newAdditionalInfo.data.data[0].id);
                                const newChunk = await getChunkInfo(newAdditionalInfo.data.data[0].id);
                                setChunk(newChunk.data.data);
                              } else {
                                setSelectedAdditionalInfo(null);
                                setChunk([]);
                              }
                              if (!isEmpty(actualAlert.reports)) {
                                setTime(0);
                                setSelectedAlert(actualAlert);
                                let reportIndex = null;
                                for (
                                  let alertRepIndex = 0;
                                  alertRepIndex < actualAlert.reports.length;
                                  alertRepIndex++
                                ) {
                                  if (
                                    !isNil(actualAlert.reports[alertRepIndex]) &&
                                    !isEmpty(actualAlert.reports[alertRepIndex])
                                  ) {
                                    reportIndex = alertRepIndex;
                                    break;
                                  }
                                }
                                if (!isNil(reportIndex)) {
                                  reportFiling({
                                    id: actualAlert.reports[reportIndex].id,
                                    setReport,
                                    setReportImages,
                                    setReportFiles,
                                    setLoading,
                                  });
                                } else {
                                  reportFiling({
                                    id: actualAlert.reports[0].id,
                                    setReport,
                                    setReportImages,
                                    setReportFiles,
                                    setLoading,
                                  });
                                }

                                setSelectedAlert(actualAlert);
                              } else {
                                setReport(null);
                                setReportFiles(null);
                                setLoading(false);
                                setSelectedAlert(actualAlert);
                              }
                            }
                          }}
                        />
                      </LocalizationProvider>
                    )}
                    {!isNil(timeOptions) && !isEmpty(timeOptions) && (
                      <TextField
                        variant="outlined"
                        margin="dense"
                        id="trace_date"
                        label={intl.formatMessage({ id: "time" })}
                        select
                        style={{ width: 150 }}
                        value={time}
                        onChange={async (event) => {
                          dataReceivedRef.current = false;
                          navigate("/analysis", { replace: true });
                          setLoading(true);
                          if (filter === "measurands") {
                            setLoading(false);
                          }
                          if (filter === "alerts") {
                            const formattedDate = `${dateOptions[date]}T${timeOptions[event.target.value]}`;
                            const actualAlert = assetAlerts.find(
                              (alert) =>
                                alert.dateStart === formattedDate ||
                                alert.dateStart === `${dateOptions[date]} ${timeOptions[event.target.value]}`,
                            );
                            const newAdditionalInfo = await getAlertAdditionalInfo(actualAlert.id);
                            setAlertAdditionalInfo(newAdditionalInfo.data.data); // esto se setea para conseguir los chunks
                            if (!isEmpty(newAdditionalInfo.data.data)) {
                              setSelectedAdditionalInfo(newAdditionalInfo.data.data[0].id);
                              const newChunk = await getChunkInfo(newAdditionalInfo.data.data[0].id);
                              setChunk(newChunk.data.data);
                            } else {
                              setSelectedAdditionalInfo(null);
                              setChunk([]);
                            }
                            if (!isEmpty(actualAlert.reports)) {
                              setSelectedAlert(actualAlert);
                              reportFiling({
                                id: actualAlert.reports[0].id,
                                setReport,
                                setReportImages,
                                setReportFiles,
                                setLoading,
                              });
                            } else {
                              setSelectedAlert(actualAlert);
                              setReport(null);
                              setReportFiles(null);
                            }
                          }
                          setTime(event.target.value);
                          setLoading(false);
                        }}
                      >
                        {timeOptions?.map((opt, i) => {
                          if (Array.isArray(opt))
                            return (
                              <MenuItem key={`times-${i}`} value={i}>
                                {opt[0].replace(/\.\d+(?=\+)/, "")}
                              </MenuItem>
                            );
                          return (
                            <MenuItem key={`times-${i}`} value={i}>
                              {opt.replace(/\.\d+(?=\+)/, "")}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    )}
                  </>
                )}

                {filter === "alerts" && !isNil(selectedAlert) && (
                  <>
                    {!isNil(subList) && (
                      <TextField
                        select
                        style={{ width: 150 }}
                        id="sub_list_alert"
                        variant="outlined"
                        label={intl.formatMessage({ id: "sub" })}
                        margin="dense"
                        value={selectedSub}
                        onChange={(event) => {
                          navigate("/analysis", { replace: true });
                          dataReceivedRef.current = false;
                          setEquipmentAndChannelData({
                            setAssetSensors,
                            assetInfo,
                            configData,
                            channelParam: null,
                            equipmentID: null,
                            equipmentTypes,
                            moduleName: assetModule,
                            newPackage: null,
                            anyTrue: measurementAny,
                            selectedSub: event.target.value,
                            subList: subList,
                            param: false,
                            setAssetEquipments,
                            setAsignedChannels,
                            setChannel,
                            setEquipment,
                            setEquipmentChannels,
                            setMeasurandsFiltered,
                            setMeasurandsOptions,
                            setSelectedEquipment,
                            setSelectedSub,
                            setSubList,
                            setFilter,
                            alertsList,
                            setAssetAlerts,
                            setAssetEvent,
                            setAssetEventList,
                            setDateTimeList,
                            setSelectedAlert,
                            setMeasurementActive,
                            setNonMeasurands,
                          });
                        }}
                      >
                        {subList.map((sub, i) => {
                          return (
                            <MenuItem key={`${sub.name}_current_select_${i}`} value={sub}>
                              {sub.name}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    )}
                    {!isNil(assetEquipments) &&
                      (() => {
                        const actualChannel = selectedEquipment.channels[channel - 1];
                        return (
                          <TextField
                            select
                            style={{ width: 150 }}
                            id="asset_equipments_alert"
                            variant="outlined"
                            label={intl.formatMessage({ id: "equipments" })}
                            margin="dense"
                            value={`${equipment}|${actualChannel.name}`}
                            onChange={(event) => {
                              navigate("/analysis", { replace: true });
                              dataReceivedRef.current = false;
                              setLoading(true);
                              const [selectedEquipmentID, selectedChannelName] = event.target.value.split("|");

                              const newEquipment = assetInfo.equipments.find(
                                (item) => item.equipmentID === selectedEquipmentID,
                              );
                              setSelectedEquipment(newEquipment);
                              const printChannel = newEquipment.channels.findIndex(
                                (channel) => channel.name === selectedChannelName,
                              );

                              const newAlertList = alertsList.measurements.filter(
                                (alert) =>
                                  alert.asset === asset &&
                                  alert.module === assetModule &&
                                  alert.substructure === selectedSub.ref,
                              );
                              if (newAlertList.length === 0) {
                                toast.info(intl.formatMessage({ id: "no.data" }), { className: "toast-info" });
                                return;
                              }
                              const auxEvents = newAlertList.map((alert) => alert.package);
                              const newEvents = auxEvents.filter((item, index) => auxEvents.indexOf(item) === index);
                              setAssetEventList(newEvents);
                              setAssetEvent(newEvents[0]);
                              setAssetAlerts(newAlertList);
                            }}
                          >
                            {assetEquipments.map((ae, i) =>
                              ae.channels.map((channel) => {
                                const found = channel.substructures.find((sub) => sub === selectedSub.ref);
                                if (isNil(found) || isEmpty(found)) return null;
                                return (
                                  <MenuItem
                                    key={`${ae.equipmentID}_current_select_${i}`}
                                    value={`${ae.equipmentID}|${channel.name}`}
                                  >
                                    {ae.name} - {channel.name}
                                  </MenuItem>
                                );
                              }),
                            )}
                          </TextField>
                        );
                      })()}

                    <TextField
                      select
                      style={{ width: 150 }}
                      id="date_alerts"
                      label={intl.formatMessage({ id: "date" })}
                      variant="outlined"
                      margin="dense"
                      value={dateOptions[date]}
                      onChange={async (event) => {
                        setLoading(true);
                        const value = event.target.value;
                        navigate("/analysis", { replace: true });
                        const newDate = dateOptions.indexOf(value);
                        const newTimeOptions = alertTimes[dateOptions.indexOf(value)];
                        setTimeOptions(newTimeOptions);
                        setDate(newDate);
                        setTime(0);
                        const actualAlert = assetAlerts.find(
                          (aa) => aa.package === assetEvent && aa.id === newTimeOptions[0][1],
                        );
                        //const newDateTime = `${dateOptions[newDate]}T${newTimeOptions[0][1]}`;
                        //const actualAlert =
                        //  !isNil(newDateTime) && !isNil(dateOptions[date]) && !isNil(newTimeOptions[0])
                        //    ? newAlerts.find((aa) => aa.dateStart === newDateTime)
                        //    : newAlerts[0];

                        setSelectedAlert(actualAlert);
                        const newAdditionalInfo = await getAlertAdditionalInfo(actualAlert.id);
                        setAlertAdditionalInfo(newAdditionalInfo.data.data); // esto se setea para conseguir los chunks
                        if (!isEmpty(newAdditionalInfo.data.data)) {
                          setSelectedAdditionalInfo(newAdditionalInfo.data.data[0].id);
                          const newChunk = await getChunkInfo(newAdditionalInfo.data.data[0].id);
                          setChunk(newChunk.data.data);
                        } else {
                          setSelectedAdditionalInfo(null);
                          setChunk([]);
                        }

                        let reportIndex = null;
                        if (!isNil(actualAlert.reports)) {
                          for (let alertRepIndex = 0; alertRepIndex < actualAlert.reports.length; alertRepIndex++) {
                            if (
                              !isNil(actualAlert.reports[alertRepIndex]) &&
                              !isEmpty(actualAlert.reports[alertRepIndex])
                            ) {
                              reportIndex = alertRepIndex;
                              break;
                            }
                          }
                        }
                        if (!isNil(reportIndex)) {
                          reportFiling({
                            id: actualAlert.reports[reportIndex].id,
                            setReport,
                            setReportImages,
                            setReportFiles,
                            setLoading,
                          });
                        } else {
                          setReport();
                          setReportImages();
                          setReportFiles();
                          setLoading(false);
                        }
                      }}
                    >
                      {dateOptions.map((dateOption, optionIndex) => (
                        <MenuItem key={`${dateOption}_current_select_${optionIndex}`} value={dateOption}>
                          {dateOption}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField
                      select
                      style={{ width: 150 }}
                      id="time_alerts"
                      label={intl.formatMessage({ id: "time" })}
                      variant="outlined"
                      margin="dense"
                      value={timeOptions[time][1]}
                      onChange={async (event) => {
                        setLoading(true);
                        navigate("/analysis", { replace: true });
                        const value = event.target.value;
                        setTime(timeOptions.findIndex((item) => item[1] === value));
                        const actualAlert = assetAlerts.find((aa) => aa.package === assetEvent && aa.id === value);
                        //const newDateTime = `${dateOptions[date]}T${timeOptions[value]}`;
                        //const actualAlert =
                        //  !isNil(newDateTime) && !isNil(dateOptions[date]) && !isNil(timeOptions[value])
                        //    ? newAlerts.find((aa) => aa.dateStart === newDateTime)
                        //    : newAlerts[0];

                        setSelectedAlert(actualAlert);
                        const newAdditionalInfo = await getAlertAdditionalInfo(actualAlert.id);
                        setAlertAdditionalInfo(newAdditionalInfo.data.data); // esto se setea para conseguir los chunks
                        if (!isEmpty(newAdditionalInfo.data.data)) {
                          setSelectedAdditionalInfo(newAdditionalInfo.data.data[0].id);
                          const newChunk = await getChunkInfo(newAdditionalInfo.data.data[0].id);
                          setChunk(newChunk.data.data);
                        } else {
                          setSelectedAdditionalInfo(null);
                          setChunk([]);
                        }

                        let reportIndex = null;
                        if (!isNil(actualAlert.reports)) {
                          for (let alertRepIndex = 0; alertRepIndex < actualAlert.reports.length; alertRepIndex++) {
                            if (
                              !isNil(actualAlert.reports[alertRepIndex]) &&
                              !isEmpty(actualAlert.reports[alertRepIndex])
                            ) {
                              reportIndex = alertRepIndex;
                              break;
                            }
                          }
                        }
                        if (!isNil(reportIndex)) {
                          reportFiling({
                            id: actualAlert.reports[reportIndex].id,
                            setReport,
                            setReportImages,
                            setReportFiles,
                            setLoading,
                          });
                        } else {
                          setReport();
                          setReportImages();
                          setReportFiles();
                          setLoading(false);
                        }
                      }}
                    >
                      {timeOptions.map((timeOption, optionIndex) => (
                        <MenuItem key={`${timeOption}_current_select_${optionIndex}`} value={timeOption[1]}>
                          {timeOption[0]}
                        </MenuItem>
                      ))}
                    </TextField>
                  </>
                )}
              </div>
              {!isNil(selectedEquipment) && filter === "measurands" && (
                <Autocomplete
                  multiple
                  id="multiple-checkboxes"
                  value={measurandsFiltered}
                  options={measurandsOptions}
                  disableCloseOnSelect
                  onChange={(event, values) => {
                    const sensorCats = [];
                    if (!isNil(assetInfo.config.additionalSensors)) {
                      for (let indexMeasurand = 0; indexMeasurand < values.length; indexMeasurand++) {
                        const checkSensor = assetInfo.config.additionalSensors.measurands.some(
                          (m) => m.category === values[indexMeasurand],
                        );
                        if (checkSensor) sensorCats.push(values[indexMeasurand]);
                      }
                      if (!isEmpty(assetSensors) && !isEmpty(sensorCats)) {
                        const catRefs = {};
                        for (let index = 0; index < sensorCats.length; index++) {
                          const mAux = assetInfo.config.additionalSensors.measurands.filter(
                            (m) => m.category === sensorCats[index],
                          );
                          const refs = mAux.map((m) => m.reference);
                          catRefs[sensorCats[index]] = refs;
                        }
                        getCurrentIntensityData({
                          asset,
                          assetInfo,
                          assetSensors,
                          sensorCats,
                          catRefs,
                          afterAlert,
                          channel,
                          selectedSub,
                          data,
                          dateTimeList,
                          endIndex,
                          equipment,
                          selectedEquipment,
                          setIntesityData,
                          startDate,
                          startIndex,
                          setLoadingIntensity,
                        });
                      } else {
                        setIntesityData();
                      }
                    }

                    setMeasurandsFiltered(values);
                  }}
                  getOptionLabel={(option) => intl.formatMessage({ id: option })}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox style={{ marginRight: 8 }} checked={selected} />
                      {intl.formatMessage({ id: option })}
                    </li>
                  )}
                  style={{ width: 300 }}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        label={intl.formatMessage({ id: option })}
                        style={{ maxWidth: 150 }}
                      />
                    ))
                  }
                  limitTags={2}
                  getLimitTagsText={(more) => <span>+{more}</span>}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" label={intl.formatMessage({ id: "select.graphs" })} />
                  )}
                />
              )}
              {/*!isNil(refs.current) && !isEmpty(refs.current) && !isNil(currentAsset) && (
              <ExportToWord
                asset={asset}
                date={dateOptions[date]}
                time={timeOptions[time]}
                charts={currentAsset.pMeasureNames.map((m, i) => ({ title: m, ref: refs.current[i] }))}
              />
            )*/}
              {filter === "measurands" && (
                <Button
                  variant="contained"
                  style={{ height: "2.5rem", backgroundColor: palette.primary, color: "white" }}
                  size="small"
                  onClick={() => setOpenModal(true)}
                >
                  {intl.formatMessage({ id: "add reading" })}
                </Button>
              )}
            </div>
            <div
              style={{
                display: "grid",
                gap: "1rem",
                overflowY: "scroll",
                overflowX: "hidden",
                width: "98%",
                height: "75vh",
              }}
            >
              {filter === "measurands" && (
                <>
                  {!isNil(dateTimeList) && !isEmpty(dateTimeList) && !isNil(selectedEquipment) ? (
                    // eslint-disable-next-line array-callback-return
                    measurandsFiltered.map((m, i) => {
                      return BOOLEAN_MEASURES.includes(m) ? (
                        <div
                          style={{
                            position: "relative",
                            width: "99%",
                          }}
                          key={`${asset}-boolean-${m}-${i}_div`}
                          ref={(ref) => (refs.current[i] = ref)}
                        >
                          {!isNil(booleanData) && !isEmpty(booleanData) ? (
                            <BooleanDataVisualization
                              key={`${asset}-boolean-${m}-${i}`}
                              data={booleanData.map((d) => (!isNil(d[m]) ? { ...d[m], pk: d.pk } : {}))}
                              measureName={m}
                              assetName={asset}
                              asignedChannels={asignedChannels}
                              currentAsset={currentAsset}
                              title={m}
                              assetsPoints={assetsPoints}
                              initialPointIndex={startIndex ?? 0}
                              endPointIndex={endIndex ?? booleanData?.[0]?.[m]?.values?.length - 1}
                              loadingTemporal={loadingTemporal}
                              scales={scales}
                              percentiles={percentiles}
                              differences={differences}
                              equipment={equipment}
                              channel={channel}
                              selectedEquipment={selectedEquipment}
                            />
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                height: "20rem",
                                backgroundColor: "rgb(176 176 176 / 60%)",
                                zIndex: 1000,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                                margin: "1rem",
                                padding: "0.5rem",
                                gap: "1rem",
                              }}
                            >
                              {`${intl.formatMessage({ id: "loading" })}...`}
                            </div>
                          )}
                        </div>
                      ) : (
                        <div
                          style={{
                            position: "relative",
                            width: "99%",
                          }}
                          key={`${asset}-boolean-${m}-${i}_div`}
                          ref={(ref) => (refs.current[i] = ref)}
                        >
                          {!isNil(data) && !isEmpty(data) && !isNil(m) ? (
                            selectedEquipment.equipmentType !== "A-DTS" ? (
                              selectedSub.type === "generic" ? (
                                <NormalDataVisualization
                                  key={`${asset}-normal-${m}-${i}`}
                                  data={data.map((d) =>
                                    !isNil(d[m])
                                      ? {
                                          ...d[m],
                                          ...(m.includes("dob") || m === "DoB" ? { pk: d[m].pk } : { pk: d.pk }),
                                        }
                                      : {},
                                  )}
                                  allData={data}
                                  setData={setData}
                                  measurandsFiltered={measurandsFiltered}
                                  currentAsset={currentAsset}
                                  assetName={asset}
                                  asignedChannels={asignedChannels}
                                  title={m}
                                  measureName={m}
                                  assetModule={assetModule}
                                  configData={configData}
                                  //boundaries={currentAsset.pBoundaries[i]}
                                  //initialPointIndex={startIndex ?? 0}
                                  //endPointIndex={endIndex ?? data?.[0]?.[m]?.values?.length - 1}
                                  assetsPoints={assetsPoints}
                                  temporalData={temporalData?.[m]}
                                  maxsW={maxsW}
                                  minsW={minsW}
                                  isAlert={!isNil(dateTime)}
                                  loadingTemporal={loadingTemporal}
                                  datetime={dateTimeList.length > 1 ? dateTimeList[date][0] : dateTimeList[0][0]}
                                  dateTimeList={dateTimeList}
                                  scales={scales}
                                  percentiles={percentiles}
                                  differences={differences}
                                  equipment={equipment}
                                  channel={channel}
                                  substructure={selectedSub}
                                  selectedEquipment={selectedEquipment}
                                  colorMaps={configData.colorMaps}
                                  alertMeasure={auxAlertMeasure}
                                  startDate={startDate}
                                  afterAlert={afterAlert}
                                  setAfterAlert={setAfterAlert}
                                  intensityData={intensityData}
                                  assetSensors={assetSensors}
                                  assetInfo={assetInfo}
                                  nonMeasurands={nonMeasurands}
                                  alertsList={alertsList}
                                  allAlerts={allAlerts}
                                  userData={userData}
                                  dobDates={dobDates}
                                  setDobDates={setDobDates}
                                />
                              ) : null
                            ) : (
                              m !== "voltages" && (
                                <ADTSVisualization
                                  key={`${asset}-normal-${m}-${i}`}
                                  data={data}
                                  allData={data}
                                  setData={setData}
                                  measurandsFiltered={measurandsFiltered}
                                  currentAsset={currentAsset}
                                  assetName={asset}
                                  asignedChannels={asignedChannels}
                                  title={m}
                                  measureName={m}
                                  assetModule={assetModule}
                                  configData={configData}
                                  //boundaries={currentAsset.pBoundaries[i]}
                                  //initialPointIndex={startIndex ?? 0}
                                  //endPointIndex={endIndex ?? data?.[0]?.[m]?.values?.length - 1}
                                  assetsPoints={assetsPoints}
                                  temporalData={temporalData?.[m]}
                                  maxsW={maxsW}
                                  minsW={minsW}
                                  isAlert={!isNil(dateTime)}
                                  loadingTemporal={loadingTemporal}
                                  datetime={dateTimeList.length > 1 ? dateTimeList[date][0] : dateTimeList[0][0]}
                                  dateTimeList={dateTimeList}
                                  scales={scales}
                                  percentiles={percentiles}
                                  differences={differences}
                                  equipment={equipment}
                                  channel={channel}
                                  substructure={selectedSub}
                                  selectedEquipment={selectedEquipment}
                                  colorMaps={configData.colorMaps}
                                  alertMeasure={auxAlertMeasure}
                                  startDate={startDate}
                                  afterAlert={afterAlert}
                                  setAfterAlert={setAfterAlert}
                                  intensityData={intensityData}
                                  assetSensors={assetSensors}
                                  assetInfo={assetInfo}
                                  nonMeasurands={nonMeasurands}
                                  alertsList={alertsList}
                                  allAlerts={allAlerts}
                                  userData={userData}
                                  dobDates={dobDates}
                                />
                              )
                            )
                          ) : (
                            /*<InclinometerDataVisualization
                                key={`${asset}-normal-${m}-${i}`}
                                data={data.map((d) => (!isNil(d[m]) ? { ...d[m], pk: d.pk } : {}))}
                                currentAsset={currentAsset}
                                assetName={asset}
                                asignedChannels={asignedChannels}
                                title={m}
                                measureName={m}
                                assetModule={assetModule}
                                configData={configData}
                                //boundaries={currentAsset.pBoundaries[i]}
                                //initialPointIndex={startIndex ?? 0}
                                //endPointIndex={endIndex ?? data?.[0]?.[m]?.values?.length - 1}
                                assetsPoints={assetsPoints}
                                temporalData={temporalData?.[m]}
                                maxsW={maxsW}
                                minsW={minsW}
                                isAlert={!isNil(dateTime)}
                                loadingTemporal={loadingTemporal}
                                datetime={dateTimeList.length > 1 ? dateTimeList[date][0] : dateTimeList[0][0]}
                                dateTimeList={dateTimeList}
                                scales={scales}
                                percentiles={percentiles}
                                differences={differences}
                                equipment={equipment}
                                channel={channel}
                                substructure={selectedSub}
                                selectedEquipment={selectedEquipment}
                                colorMaps={configData.colorMaps}
                                alertMeasure={auxAlertMeasure}
                                startDate={startDate}
                                afterAlert={afterAlert}
                                setAfterAlert={setAfterAlert}
                                intensityData={intensityData}
                                assetSensors={assetSensors}
                                assetInfo={assetInfo}
                              />*/
                            <div
                              style={{
                                width: "100%",
                                height: "20rem",
                                backgroundColor: "rgb(176 176 176 / 60%)",
                                zIndex: 1000,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                                margin: "1rem",
                                padding: "0.5rem",
                                gap: "1rem",
                              }}
                            >
                              {`${intl.formatMessage({ id: isEmpty(data) ? "no.data" : "loading" })}...`}
                            </div>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <div
                      style={{ height: "50vh", display: "flex", justifyContent: "center", alignItems: "center" }}
                    >{`${intl.formatMessage({ id: "loading" })}...`}</div>
                  )}
                </>
              )}
              {filter === "alerts" && (
                <div style={{ marginLeft: "1%", marginRight: "1%", position: "relative" }}>
                  {!isNil(selectedAlert) ? (
                    <div
                      style={{
                        fontSize: "1.2rem",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        gap: "16px",
                      }}
                    >
                      <div
                        style={{
                          borderRadius: "10px",
                          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                          overflow: "hidden",
                          backgroundColor: palette.primary,
                          width: "45%",
                        }}
                      >
                        <h2 style={{ padding: "2%", color: "white" }}>{intl.formatMessage({ id: "alert.info" })}</h2>
                        <div style={{ padding: "2%", backgroundColor: palette.likeWhite }}>
                          <span style={{ marginTop: "1%" }}>
                            <b>{intl.formatMessage({ id: "channel" })}:</b> <span>{selectedAlert.channel}</span>
                          </span>
                          <br />
                          <span style={{ marginTop: "1%" }}>
                            <b>{intl.formatMessage({ id: "sub" })}:</b> <span>{selectedAlert.substructure}</span>
                          </span>
                          <br />
                          {!isNil(selectedAlert.package) && (
                            <>
                              <span style={{ marginTop: "1%" }}>
                                <b>{intl.formatMessage({ id: "event.type" })}:</b>{" "}
                                <span>{intl.formatMessage({ id: selectedAlert.package })}</span>
                              </span>
                              <br />
                            </>
                          )}
                          <span style={{ marginTop: "1%" }}>
                            <b>{intl.formatMessage({ id: "severity" })}:</b>{" "}
                            <span>
                              <BadgeReturn alert={selectedAlert} />
                            </span>
                          </span>
                          <br />
                          <span style={{ marginTop: "1%" }}>
                            <b>{intl.formatMessage({ id: "start.date" })}:</b>{" "}
                            <span>{selectedAlert.dateStart.replace(/\.\d+(?=\+)/, "").replace("T", " ")}</span>
                          </span>
                          <br />
                          <span style={{ marginTop: "1%" }}>
                            <b>{intl.formatMessage({ id: "end.date" })}:</b>{" "}
                            <span>{selectedAlert.dateEnd.replace(/\.\d+(?=\+)/, "").replace("T", " ")}</span>
                          </span>
                          <br />
                          {!isNil(report) && !isEmpty(report) && (
                            <span style={{ marginTop: "1%" }}>
                              <b>{intl.formatMessage({ id: "description" })}:</b> <span>{report.content}</span>
                            </span>
                          )}
                        </div>
                      </div>
                      <MapAlert
                        assetData={currentAsset}
                        assetEquipments={assetEquipments}
                        points={assetsPoints}
                        alert={selectedAlert}
                        intl={intl}
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgb(176 176 176 / 60%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        position: "absolute",
                      }}
                    >{`${intl.formatMessage({ id: "no.alert" })}`}</div>
                  )}

                  <br />
                  {!isNil(selectedAlert) && !isNil(report) && (
                    <TabContext value={value}>
                      <Tabs value={value} onChange={handleChange} style={{ backgroundColor: "rgb(211, 211, 208)" }}>
                        {selectedAlert.reports.map((report, reportIndex) => (
                          <Tab
                            id={`tab${reportIndex}`}
                            value={reportIndex + 1}
                            label={`${intl.formatMessage({ id: "report" })} ${reportIndex + 1}`}
                            key={`tab${reportIndex}_key`}
                          />
                        ))}
                      </Tabs>

                      <TabPanel
                        sx={{ flex: 1, overflow: "auto", width: "100%", backgroundColor: "rgb(211, 211, 208)" }}
                        value={value}
                      >
                        {!isNil(report) && !isEmpty(report) && (
                          <div style={{ fontSize: "1.2rem", marginBottom: "1rem" }}>
                            <span style={{ marginTop: "1%" }}>
                              <b>{intl.formatMessage({ id: "author" })}:</b>{" "}
                              <span>
                                {report.authorInfo.name}-{report.authorInfo.organization}
                              </span>
                              <br />
                            </span>
                            <span style={{ marginTop: "1%" }}>
                              <b>{intl.formatMessage({ id: "created.at" })}:</b>{" "}
                              <span>{report.createdAt.replace(/\.\d+$/, "").replace("T", " ")}</span>
                            </span>
                            <br />
                            <span style={{ marginTop: "1%" }}>
                              <b>{intl.formatMessage({ id: "last.update" })}:</b>{" "}
                              <span>{report.updatedAt.replace(/\.\d+$/, "").replace("T", " ")}</span>
                            </span>
                            <br />
                          </div>
                        )}
                        {!isNil(reportFiles) && !isNil(reportImages) && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "flex-start",
                              gap: "16px",
                            }}
                          >
                            {/* Contenedor de imágenes a la izquierda */}
                            <div style={{ display: "flex", flexDirection: "column", gap: "8px", flex: 1 }}>
                              {!isNil(reportImages) && !isEmpty(reportImages) && (
                                <>
                                  <Carousel
                                    autoPlay={false} // Desactiva el auto-play
                                    navButtonsAlwaysVisible // Mantiene siempre visibles los botones de navegación
                                    indicators={true} // Muestra los indicadores (puntos) en la parte inferior
                                    cycleNavigation={true} // Permite navegación cíclica (del último al primero)
                                    swipe={true}
                                    height="27rem"
                                    NavButton={({ onClick, className, style, next, prev }) => {
                                      // Botones de navegación personalizados
                                      const buttonStyle = {
                                        backgroundColor: "rgba(48, 45, 45, 0.8)",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "50%",
                                        width: "40px",
                                        height: "40px",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "18px",
                                        fontWeight: "bold",
                                        position: "absolute",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        zIndex: 2,
                                        ...(next && { right: "10px" }),
                                        ...(prev && { left: "10px" }),
                                      };
                                      return (
                                        <button onClick={onClick} className={className} style={buttonStyle}>
                                          {next && ">"}
                                          {prev && "<"}
                                        </button>
                                      );
                                    }}
                                  >
                                    {reportImages?.map((attachment, attachmentIndex) => {
                                      return (
                                        <div
                                          key={`${attachment.filename}_carousel_${attachmentIndex}`}
                                          style={{
                                            height: "27rem",
                                            width: "100%",
                                            display: "flex",
                                            alignItems: "center", // centra vertical
                                            justifyContent: "center", // centra horizontal
                                            position: "relative",
                                            backgroundColor: "#000", // opcional (recomendado)
                                          }}
                                        >
                                          <button
                                            key={`${attachment.filename}_carousel_${attachmentIndex}_button`}
                                            onClick={() => {
                                              const link = document.createElement("a");
                                              link.href = `data:image/png;base64,${attachment.content}`;
                                              link.download = attachment.filename;
                                              document.body.appendChild(link);
                                              link.click();
                                              document.body.removeChild(link);
                                            }}
                                            style={{
                                              position: "absolute",
                                              top: "2%",
                                              right: "6%",
                                              zIndex: 10,
                                              background: "rgba(0,0,0,0.6)",
                                              color: "white",
                                              border: "none",
                                              padding: "5px 10px",
                                              borderRadius: "4px",
                                              cursor: "pointer",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <DownloadIcon />
                                          </button>
                                          <button
                                            onClick={() => {
                                              setSelectedImage(attachment);
                                              setDialogImage(true);
                                            }}
                                            style={{
                                              position: "absolute",
                                              top: "2%",
                                              right: "12%",
                                              zIndex: 10,
                                              background: "rgba(0,0,0,0.6)",
                                              color: "white",
                                              border: "none",
                                              padding: "5px 10px",
                                              borderRadius: "4px",
                                              cursor: "pointer",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <FullscreenIcon />
                                          </button>
                                          <Dialog fullScreen open={dialogImage} onClose={() => setDialogImage(false)}>
                                            <div
                                              style={{
                                                height: "100vh",
                                                width: "100vw",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                backgroundColor: "black",
                                                position: "relative",
                                              }}
                                            >
                                              {/* Botón cerrar */}
                                              <button
                                                onClick={() => setDialogImage(false)}
                                                style={{
                                                  position: "absolute",
                                                  top: "2%",
                                                  right: "2%",
                                                  zIndex: 10,
                                                  background: "rgba(0,0,0,0.6)",
                                                  color: "white",
                                                  border: "none",
                                                  padding: "6px 10px",
                                                  borderRadius: "4px",
                                                  cursor: "pointer",
                                                }}
                                              >
                                                ✕
                                              </button>

                                              {selectedImage && (
                                                <img
                                                  src={`data:image/png;base64,${selectedImage.content}`}
                                                  alt={selectedImage.filename}
                                                  style={{
                                                    maxWidth: "100%",
                                                    maxHeight: "100%",
                                                    objectFit: "contain",
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </Dialog>

                                          <img
                                            src={`data:image/png;base64,${attachment.content}`}
                                            alt={attachment.filename}
                                            style={{
                                              maxWidth: "100%",
                                              maxHeight: "100%",
                                              objectFit: "contain",
                                              display: "block",
                                            }}
                                          />
                                        </div>
                                      );
                                    })}
                                  </Carousel>
                                </>
                              )}
                              {(isNil(reportImages) || isEmpty(reportImages)) && (
                                <center>
                                  <img key={`NO IMAGE CAROUSEL`} src={noImage} alt={`NO FOUND`} width={"400rem"} />
                                </center>
                              )}
                            </div>

                            {/* Contenedor de chips a la derecha con anchura reducida */}
                            <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "50%" }}>
                              {reportFiles?.map((attachment, attachmentIndex) => {
                                const extension = obtainExtension(attachment.filename);
                                const imageChecker = fileType(extension, [
                                  "jpg",
                                  "jpeg",
                                  "png",
                                  "gif",
                                  "bmp",
                                  "svg",
                                  "webp",
                                  "tiff",
                                ]);
                                if (!imageChecker) {
                                  return (
                                    <Chip
                                      key={`${attachment.filename}_${attachmentIndex}`}
                                      label={
                                        <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                          {attachment.filename}
                                          <IconDisplay filename={attachment.filename} fileIndex={attachmentIndex} />
                                        </span>
                                      }
                                    />
                                  );
                                }
                                return null;
                              })}
                            </div>
                          </div>
                        )}
                      </TabPanel>
                    </TabContext>
                  )}
                  {loadingReport && (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgb(176 176 176 / 60%)",
                        zIndex: 2000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        position: "absolute",
                      }}
                    >
                      {`${intl.formatMessage({ id: "loading" })}...`}
                    </div>
                  )}

                  {!isNil(selectedAlert) && !isNil(alertAdditionalInfo) && !isEmpty(alertAdditionalInfo) && (
                    <>
                      <h2 style={{ marginTop: "3%", fontSize: "1.2rem" }}>{intl.formatMessage({ id: "raw.data" })}</h2>
                      <div style={{ marginTop: "10px", display: "flex", justifyContent: "center" }}>
                        <Button disabled={disabled} startIcon={<ArrowBackIos />} onClick={goToPrevious} />
                        <h2 style={{ color: palette.primary }}>
                          {currentIndex + 1}/{alertAdditionalInfo.length}
                        </h2>
                        <Button disabled={disabled} startIcon={<ArrowForwardIos />} onClick={goToNext} />
                      </div>
                      {chartChunk && chunk && <WaterfallChart data={chartChunk} intl={intl} />}
                    </>
                  )}
                </div>
              )}
              {!isNil(intensityData) && !isEmpty(intensityData) && (
                <CurrentIntensityVisualization
                  intensityData={intensityData}
                  afterAlert={afterAlert}
                  assetSensors={assetSensors}
                  assetModule={assetModule}
                  configData={configData}
                  assetInfo={assetInfo}
                  data={data}
                  measurandsFiltered={measurandsFiltered}
                  dateTimeList={dateTimeList}
                  key={`intensity chart`}
                  info={{
                    asset: asset,
                    equipment: selectedEquipment,
                    channel: channel,
                    dateTime: dateTimeList[0][0],
                    substructure: selectedSub,
                  }}
                  intl={intl}
                />
              )}
              {loadingIntensity && (
                <div
                  style={{
                    width: "100%",
                    height: "20rem",
                    backgroundColor: "rgb(176 176 176 / 60%)",
                    zIndex: 1000,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    margin: "1rem",
                    padding: "0.5rem",
                    gap: "1rem",
                  }}
                >
                  {`${intl.formatMessage({ id: "loading" })}...`}
                </div>
              )}
            </div>
          </div>
        </ThemeProvider>
        {filter === "measurands" && (
          <AddTraceModal
            key={`add_trace_modal_${asset}_${equipment}_${channel}`}
            asset={asset}
            equipment={equipment}
            channel={channel}
            open={openModal}
            setOpen={setOpenModal}
            timeOptionsModal={timeOptionsModal}
            dateOptionsModal={dateOptionsModal}
            setTimeOptionsModal={setTimeOptionsModal}
            setDateOptionsModal={setDateOptionsModal}
            equipmentChannels={equipmentChannels}
            selectedEquipment={selectedEquipment}
            assetEquipments={assetEquipments}
            assetModule={assetModule}
            firstTime={firstTime}
            setFirstTime={setFirstTime}
            asignedChannels={asignedChannels}
            substructure={selectedSub}
            filter={filter}
            assetInfo={assetInfo}
            subList={subList}
            setSelectedEquipment={setSelectedEquipment}
            dataReceivedRef={dataReceivedRef}
            handleModalAccept={(dateIndex, timeIndex, modalChannel, substructure) => {
              dataReceivedRef.current = false;
              handleModalAccept({
                date: dateOptionsModal[dateIndex],
                time: timeOptionsModal[timeIndex],
                modalChannel,
                substructure,
                dateTimeList,
                setDateTimeList,
              });
            }}
          />
        )}
      </>
    );
  }
};

export default Analysis;
